import React from 'react'

import { Select } from '@driftt/dds'

interface DurationOption {
  value: number
  label: string
}

const DurationSelectOptions = [
  {
    value: 10,
    label: '10 minutes',
  },
  {
    value: 15,
    label: '15 minutes',
  },
  {
    value: 30,
    label: '30 minutes',
  },
  {
    value: 45,
    label: '45 minutes',
  },
  {
    value: 60,
    label: '60 minutes',
  },
  {
    value: 90,
    label: '90 minutes',
  },
  {
    value: 120,
    label: '120 minutes',
  },
  {
    value: 180,
    label: '180 minutes',
  },
]

interface DurationSelectProps {
  defaultDuration: number
  updateState: (duration: number) => void
  disabled: boolean
}

const DurationSelect = ({
  defaultDuration,
  updateState,
  disabled,
}: DurationSelectProps) => {
  const defaultOption = DurationSelectOptions.find(
    (option) => option.value === defaultDuration
  )

  const handleSelectionChange = (option: DurationOption) => {
    updateState(option.value)
  }

  return (
    <Select
      size={'x-large'}
      label="Duration"
      options={DurationSelectOptions}
      value={defaultOption}
      isClearable={false}
      // @ts-expect-error newValue in onChange is unknown
      onChange={handleSelectionChange}
      isDisabled={disabled}
    />
  )
}

export default DurationSelect
